module.exports = __webpack_public_path__ + "static/img/ureter-2.327542a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ureterpic/ureter-2.jpg
// module id = M0U3
// module chunks = 51